import { translationKey } from '../i18n';
import { scheduleWallTime } from './scheduleClock';

function effectiveReminderAt(log) {
    if (log.deferredUntil) return log.deferredAt || log.deferredUntil;
    return log.scheduledAt || `${log.scheduledDate || ''}T${log.scheduledTime || ''}`;
}

export function guardianOverdueMinutes(log, now = new Date()) {
    if (log.status !== 'PENDING') return 0;
    const at = new Date(effectiveReminderAt(log));
    if (Number.isNaN(at.getTime())) return 0;
    return Math.max(0, Math.floor((now.getTime() - at.getTime()) / 60000));
}

function guardianDisplayAt(log) {
    if (log.status === 'TAKEN' && log.confirmedAt) return log.confirmedAt;
    if (log.status === 'PENDING' && log.deferredUntil) return log.deferredUntil;
    return `${log.scheduledDate || ''}T${log.scheduledTime || ''}`;
}

export function formatGuardianLogTime(log, now = new Date()) {
    const [date, time = ''] = guardianDisplayAt(log).split('T');
    const today = scheduleWallTime(log.scheduleTimeZone, now).slice(0, 10);
    return `${date && date !== today ? `${date.slice(5).replace('-', '/')} ` : ''}${time.slice(0, 5)}`;
}

export function sortGuardianLogs(logs = []) {
    return [...new Map(logs.map(log => [log.id, log])).values()].sort((a, b) =>
        guardianDisplayAt(a).localeCompare(guardianDisplayAt(b))
        || (a.medicationName || '').localeCompare(b.medicationName || '')
        || (a.id || 0) - (b.id || 0));
}

export function canNudgeGuardianLog(log, now = new Date()) {
    const today = scheduleWallTime(log.scheduleTimeZone, now).slice(0, 10);
    if (!['PENDING', 'MISSED'].includes(log.status) || log.scheduledDate !== today) return false;
    const due = new Date(effectiveReminderAt(log));
    return !Number.isNaN(due.getTime()) && due <= now;
}

export function guardianSharingNotice(target) {
    if (target.deviceCount !== 0) return null;
    return target.sharingStatus === 'ACCOUNT_SIGNED_OUT'
        ? translationKey('가족 연결은 유지돼요. 가족이 기존 계정으로 다시 로그인하면 복용 현황이 다시 공유돼요.')
        : translationKey('연결된 가족 기기가 없어 현황 공유가 멈췄어요. 가족의 앱에서 연결 상태를 확인해주세요.');
}
